<template>
  <img
    class="img"
    :src="require(`@/assets/img/infograms/audit_${currentLang}.png`)"
    alt="#"
  />
</template>

<script>
export default {
  name: 'InfogramAudit',
  computed: {
    currentLang() {
      this.dic
      //this need for wake up store listner
      return this.$store.state.main.currentLang
    },
    dic() {
      //this need for wake up store listner
      return this.$store.state.main.dic
    },
  },
}
</script>

<style lang="scss" scoped>
.img {
  width: 541px;
}
</style>

<style lang="scss" scoped>
@media (max-width: 1024px) {
  .img {
    width: 480px;
  }
}

@media (max-width: 500px) {
  .img {
    width: 400px;
  }
}

@media (max-width: 414px) {
  .img {
    width: 380px;
  }
}

@media (max-width: 375px) {
  .img {
    width: 340px;
  }
}
</style>
